import { Component, Input, OnInit, ViewChild, Renderer2, Inject, AfterViewInit } from '@angular/core';
import { SwiperConfigInterface, SwiperDirective } from 'ngx-swiper-wrapper';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilService, VariablesService, SeoService, GalleryService } from '../../../../shared/services';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-img-slider',
  templateUrl: './img-slider.component.html',
  styleUrls: ['./img-slider.component.scss']
})
export class ImgSliderComponent implements OnInit, AfterViewInit {

  @Input() public gallery: any[] = [];
  @Input() public shadow = false;
  @Input() public slideType;
  @Input() config;
  @Input() public hasThumbs = false;
  @Input() public showNavs = true;
  @Input() public showOuterNavs;
  @Input() public basicInfo?;
  @Input() public isFOS = false;
  showVideo = false;
  isMobile: any;
  videoSrc;
  currentIndex = 1;
  shareButtons = [
    { button: 'twitter', icon: 'icon-twitter i-tweet', label: 'Tweet', medium: 'twShare' },
    { button: 'linkedin', icon: 'icon-linkedin i-linkedin', label: 'LinkedIn', medium: 'linkedin' },
    { button: 'email', icon: 'icon-google i-gp', label: 'Mail', medium: 'email' },
    { button: 'copy', icon: 'icon-chain i-link', label: 'Link', medium: '' },
  ];
  @Input() public swiperconfig: SwiperConfigInterface = {
    a11y: true,
    slidesPerView: 1,
    watchSlidesVisibility: true,
    direction: 'horizontal',
    keyboard: true,
    navigation: true,
    preloadImages: false,
    observer: true,
    lazy: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
    thumbs: true
  };
  thumbConfig: SwiperConfigInterface = {
    spaceBetween: 10,
    slidesPerView: 7,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: true
    // loop: true,
  };
  @ViewChild(SwiperDirective) directiveRef?: SwiperDirective;

  constructor(
    public utilService: UtilService,
    public domSanitizer: DomSanitizer,
    @Inject(DOCUMENT) public document,
    private variablesService: VariablesService,
    private seoService: SeoService,
    private galleryService: GalleryService
  ) { }

  get galleryfilter() {
    if (this.config?.theme.match('v1')) {
      return this.gallery.slice(0, 3);
    } else {
      return this.gallery;
    }
  }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    if (this.gallery) {
      for (const item of this.gallery) {
        if (item.media_type === 'video') {
          const data = {
            title: this.variablesService.metaDataOfPage.title,
            desc: this.variablesService.metaDataOfPage.description,
            videoId: this.utilService.getYouTubeId(item.path),
            startDate: this.variablesService.fundraiser.start_date
          };
          this.seoService.schamObjectForVideos(data);
        }
      }
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.slideType !== 'leaderboard' && this.utilService.isBrowser) {
        // lightGallery(this.document.getElementById('lightgallery' + this.slideType));
        this.galleryService.initGallery('lightgallery' + this.slideType);
      }
    }, 0);
  }
  /**On Index Change */
  onIndexChange(data) {
    this.currentIndex = data;
  }
  /**Move to the slider while click on thmbs */
  thumbsOnClick(i) {
    this.directiveRef.setIndex(i);
  }
  /**Add youtube emabed on demand*/
  addYoutubeEmbed(slide) {
    this.directiveRef.stopAutoplay();
    const id = this.utilService.getYouTubeId(slide.path);
    slide.videoSrc = this.domSanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0');
    slide.showVideo = true;
  }

  prev() {
    this.directiveRef.prevSlide();
  }
  next() {
    this.directiveRef.nextSlide();
  }
}
